<template>
    <projectProgress />
</template>

<script>
import projectProgress from './projectProgress';
export default {
  name: 'homeProjects',
  components: {
    projectProgress,
  },
  props: {
    msg: String
  },
  data() {
    return {
    };
  },
        mounted() {
      },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
